import Vue from 'vue';
import VueRouter from 'vue-router';

// Index
import Index from '../views/frontend/index/index.vue';
// Login
import Login from '../views/frontend/login/login.vue';
// SignUp
import SignUp from '../views/frontend/sign_up/sign_up.vue';
import EditMember from '../views/frontend/edit_member/edit_member.vue';

import error404 from '@/views/frontend/errors/404.vue';


Vue.use(VueRouter)

export default new VueRouter({
  //- 使用 meta 把 route 掛上 requiresAuth 如果是 true 就代表要檢查是否有 uuid 沒有就導回 login
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '*',
      redirect: '/404',
      component: error404,
      children: [
        {
          path: '/404',
          name: '404',
        }
      ]
    },
    //- 登入頁面
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {requiresAuth: false}
    },
    //- 註冊頁面
    {
      path: '/sign_up',
      redirect: '/sign_up/index',
      component: SignUp,
      children: [
        {
          path: '/sign_up/index',
          name: 'sign_up',
          component: () =>
            import ( /* webpackChunkName: "sign_up" */ '@/views/frontend/sign_up/index/index.vue'),
          meta: {requiresAuth: true}
        },
        {
          path: '/sign_up/pending',
          name: 'sign_up_pending',
          component: () =>
            import ( /* webpackChunkName: "sign_up" */ '@/views/frontend/sign_up/pending/index.vue'),
          meta: {requiresAuth: true}
        },
      ]
    },
    //- 編輯會員資料
    {
      path: '/editMember',
      redirect: '/editMember/index',
      component: EditMember,
      children: [
        {
          path: '/editMember/index',
          name: 'edit_member',
          component: () =>
            import ( /* webpackChunkName: "editMember" */ '@/views/frontend/edit_member/index/index.vue'),
          meta: {requiresAuth: true}
        },
        {
          path: '/editMember/pending',
          name: 'edit_member_pending',
          component: () =>
            import ( /* webpackChunkName: "editMember" */ '@/views/frontend/edit_member/pending/index.vue'),
          meta: {requiresAuth: true}
        },
      ]
    },
    //- 首頁最外層
    {
      path: '/index',
      name: 'index',
      redirect: '/index/home',
      component: Index,
      meta: {requiresAuth: true},
      children: [
        //- 首頁
        {
          path: '/index/home',
          name: 'home',
          component: () =>
            import ( /* webpackChunkName: "home" */ '@/views/frontend/index/home/index.vue'),
          meta: {requiresAuth: true}
        },
        //- 重要訊息
        {
          path: '/index/importantMessage',
          name: 'important_message',
          component: () =>
            import ( /* webpackChunkName: "important_message" */ '@/views/frontend/index/important_message/index.vue'),
          meta: {requiresAuth: true}
        },
        //- 禮物兌換 - 首頁
        {
          path: '/index/giftManager',
          name: 'gift_manager',
          component: () =>
            import ( /* webpackChunkName: "gift_manager" */ '@/views/frontend/index/gift_manager/index.vue'),
          meta: {requiresAuth: true}
        },
        //- 銷售懶人包 - 首頁
        {
          path: '/index/saleProduct',
          name: 'sale_product',
          component: () =>
            import ( /* webpackChunkName: "sale_product" */ '@/views/frontend/index/sale_product/index.vue'),
          meta: {requiresAuth: true}
        },
      ]
    },
  ]
});


